import {
  createRazorpayOrder,
  verifyRazorpayPayment,
} from "../services/resident_api";

// Initialize Razorpay payment flow
export const initiateRazorpayPayment = async ({
  plan,
  residentId,
  residentName,
  residentPhone,
  residentEmail,
  autoRenew,
}) => {
  const access = localStorage.getItem("access");

  const orderResponse = await createRazorpayOrder(
    plan.price, // ✅ use plan.price
    plan.name,
    residentName,
    residentPhone,
    residentEmail
  );

  if (orderResponse.success) {
    const order = orderResponse.data;

    const options = {
      key: "rzp_live_v6c8Actu2DaV90", // ✅ Replace with your test key in development
      amount: order.amount,
      currency: order.currency,
      name: "The Mail Whale",
      description: `Plan: ${plan.name} - ${plan.duration}`,
      order_id: order.id,
      handler: async function (response) {
        const verifyPayload = {
          order_id: response.razorpay_order_id,
          payment_id: response.razorpay_payment_id,
          signature: response.razorpay_signature,
          resident_id: residentId,
          plan_id: plan.id,
          plan_name: plan.name,
          plan_price: plan.price,
          plan_duration: plan.duration,
          auto_renew: autoRenew,
        };

        const verifyResult = await verifyRazorpayPayment(verifyPayload, access);

        if (verifyResult.success) {
          alert("✅ Payment verified and saved!");
        } else {
          alert("❌ Payment verification failed.");
        }
      },
      prefill: {
        name: residentName || "User",
        email: residentEmail || "user@example.com",
        contact: residentPhone || "9999999999",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  } else {
    alert("❌ Failed to create Razorpay order.");
  }
};
